import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ConfigService } from "@docma-mm-core/config/config.service";
import { BasedataService } from "@docma-mm-core/shared/basedata.service";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";

@Injectable()
export class DocumentTypeService extends BasedataService {
  private typeUrl: string = '/configuration/documenttypes';
  constructor(private http: HttpClient, configService: ConfigService) {
    super(configService);
  }
  private getCompanyUrl() {
    return super.getFullUrl(this.typeUrl);
  }

  getDocumentType(top: number = 1000, skip: number = 0): Observable<DocumentType> {
    let endpoint = this.getCompanyUrl();
    let httpParams = new HttpParams();
    if (top) httpParams = httpParams.set('$top', top.toString());
    if (skip) httpParams = httpParams.set('$skip', skip.toString());
    return this.http
      .get(endpoint, { headers: this.getHeaders(), params: httpParams })
      .pipe(
        map((dt: any)=> {
          return dt && dt.Data ?  dt.Data : [] ;
        }),
        catchError( e => this.handleError(e))
      );

  }
}
